import { Controller } from "@hotwired/stimulus"

// Cadastro de provedor de IA: o select de modelo mostra só os modelos do provedor escolhido
// (um optgroup por provedor, rotulado com o nome dele) e o grupo "Outro", que libera o campo
// para digitar o id de um modelo fora da lista.
export default class extends Controller {
  static targets = ["provedor", "modelo", "outro", "personalizado"]
  static values = { rotulos: Object }

  connect() {
    this.filtrar(false)
  }

  // Trocou de provedor: o modelo passa ao recomendado dele, o primeiro do grupo.
  trocarProvedor() {
    this.filtrar(true)
  }

  filtrar(escolherRecomendado) {
    const rotulo = this.rotulosValue[this.provedorTarget.value]
    let grupoDoProvedor = null

    for (const grupo of this.modeloTarget.querySelectorAll("optgroup")) {
      const visivel = grupo.label === rotulo || grupo.label === "Outro"
      grupo.hidden = !visivel
      grupo.disabled = !visivel
      if (grupo.label === rotulo) grupoDoProvedor = grupo
    }

    const selecionada = this.modeloTarget.selectedOptions[0]
    const foraDoProvedor = !selecionada || selecionada.parentElement.disabled
    const recomendado = grupoDoProvedor?.querySelector("option")
    if ((escolherRecomendado || foraDoProvedor) && recomendado) this.modeloTarget.value = recomendado.value

    this.alternarOutro()
  }

  // Pelo `change` do select vem o evento, e só aí o foco vai para o campo: ao abrir a edição
  // de um modelo digitado, o foco fica onde estava.
  alternarOutro(evento) {
    const outro = this.modeloTarget.value === "outro"
    this.outroTarget.hidden = !outro
    this.personalizadoTarget.required = outro
    if (outro && evento) this.personalizadoTarget.focus()
  }
}
